import axios from "axios";

const TOO_MANY_REQUESTS = 429;

/** Сколько ждать, если сервер не назвал срок. */
const FALLBACK_DELAY_MS = 5_000;

/**
 * Сервер отказал по лимиту запросов, а не по сути запроса.
 *
 * Троттлинг срабатывает до контроллера, поэтому ничего не выполнено и повтор
 * безопасен — в том числе для мутаций.
 */
export const isThrottled = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === TOO_MANY_REQUESTS;

/**
 * `Retry-After` приходит в секундах и указывает ровно на сброс окна лимита:
 * повтор раньше срока гарантированно получит тот же отказ.
 */
export const retryAfterMs = (error: unknown): number => {
  if (!axios.isAxiosError(error)) {
    return FALLBACK_DELAY_MS;
  }

  const seconds = Number(error.response?.headers?.["retry-after"]);

  if (!Number.isFinite(seconds) || seconds <= 0) {
    return FALLBACK_DELAY_MS;
  }

  return seconds * 1_000;
};
